import React from 'react';

import { EFakturaList } from '../../components/EFakturaList';
import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useEfaktura from '../../fetchHooks/useEfaktura';

import './VerticalEFakturaList.scss';

const VerticalEFakturaList: React.FC = () => {
    const { featureToggles } = useConfig();
    const {
        data: eFakturas = [],
        isLoading: eFakturasLoading,
        ...efakturaState
    } = useEfaktura({ enabled: !featureToggles.disableEfaktura });

    return (
        <Content>
            <EFakturaList
                type="full-list"
                eFakturas={eFakturas}
                isLoading={eFakturasLoading}
                error={efakturaState.error}
            />
        </Content>
    );
};

export default VerticalEFakturaList;
